import React from 'react';
import { motion } from 'framer-motion';
import ProjectCard from '../components/ProjectCard';

const musicProjects = [
  {
    title: 'Ambient EP: "Whispers of Dawn"',
    description: 'A four-track collection of ambient soundscapes inspired by early morning hours and the transition from night to day.',
    image: 'https://via.placeholder.com/600x400?text=Ambient+EP',
    creator: 'Roscoe' as const,
    tags: ['Ambient', 'Electronic', 'Composition'],
    link: '#'
  },
  {
    title: 'Jazz-Hip Hop Fusion Album',
    description: 'A collaborative project merging traditional jazz instrumentation with modern hip-hop production techniques.',
    image: 'https://via.placeholder.com/600x400?text=Jazz+Hip+Hop',
    creator: 'Matthew' as const,
    tags: ['Jazz', 'Hip-Hop', 'Fusion'],
    link: '#'
  },
  {
    title: 'Live Electronic Performance',
    description: 'A one-hour improvised electronic music performance using hardware synthesizers and drum machines.',
    image: 'https://via.placeholder.com/600x400?text=Live+Electronic',
    creator: 'Both' as const,
    tags: ['Live', 'Electronic', 'Improvisation'],
    link: '#'
  },
  {
    title: 'Film Score: "The Silent Path"',
    description: 'Original music composed for an independent short film exploring themes of isolation and discovery.',
    image: 'https://via.placeholder.com/600x400?text=Film+Score',
    creator: 'Roscoe' as const,
    tags: ['Film Score', 'Orchestral', 'Cinematic'],
    link: '#'
  },
  {
    title: 'Experimental Sound Design',
    description: 'A collection of experimental sound designs created from field recordings and processed through analog gear.',
    image: 'https://via.placeholder.com/600x400?text=Sound+Design',
    creator: 'Matthew' as const,
    tags: ['Experimental', 'Sound Design', 'Field Recording'],
    link: '#'
  },
  {
    title: 'Vocal Harmony Project',
    description: 'A cappella arrangements showcasing intricate vocal harmonies and innovative vocal techniques.',
    image: 'https://via.placeholder.com/600x400?text=Vocal+Harmony',
    creator: 'Both' as const,
    tags: ['Vocal', 'A Cappella', 'Harmony'],
    link: '#'
  }
];

const MusicPage: React.FC = () => {
  return (
    <div>
      <motion.div 
        className="text-center max-w-3xl mx-auto mb-12"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-bold mb-6">RANDM Music</h1>
        <p className="text-xl text-gray-600">
          Our sonic explorations across genres and techniques. From ambient compositions to 
          experimental electronic music, film scores to vocal arrangements.
        </p>
      </motion.div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {musicProjects.map((project, index) => (
          <motion.div
            key={project.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ProjectCard {...project} />
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default MusicPage; 